export default function BundlePlanCardShimmer() {
  return (
    <div className="border border-p_light_hover rounded-2xl p-4 flex flex-col gap-4" data-testid="bundle-plan-shimmer">
      <div className="flex items-start gap-4">
        <div className="w-[120px] flex flex-col gap-2">
          <div className="shimmer skeleton h-3 w-20" />
          <div className="shimmer skeleton h-5 w-14" />
        </div>

        <div className="flex-1 flex justify-end gap-1.5 flex-wrap">
          <div className="shimmer skeleton h-6 w-14 rounded-[10px]" />
          <div className="shimmer skeleton h-6 w-14 rounded-[10px]" />
        </div>

        <div className="w-px self-stretch bg-p_light_hover" />

        <div className="w-[135px] flex flex-col items-end gap-2">
          <div className="shimmer skeleton h-3 w-16" />
          <div className="shimmer skeleton h-6 w-24" />
          <div className="shimmer skeleton h-3 w-14" />
        </div>

        <div className="pt-1">
          <div className="shimmer skeleton w-5 h-5 rounded-full" />
        </div>
      </div>

      <div className="bg-information_light rounded-lg p-2 flex flex-col gap-2">
        <div className="shimmer skeleton h-3 w-20" />
        <div className="shimmer skeleton h-4 w-40" />
      </div>
    </div>
  )
}
